/** The front door: which providers this host offers, and the development shortcut past them. */
export const session = {
  signIn: {
    title: "Inloggen",
    description:
      "De backoffice is voor de wedstrijdleiders. Log in met je JBNL-account.",
    withProvider: "Inloggen met {{provider}}",
    elsewhereBefore:
      "Wil je ploegen inschrijven of je beschikbaarheid doorgeven? Ga naar ",
    elsewhereAfter: ".",
    noneConfigured: "Er is nog geen inlogmethode ingesteld voor deze omgeving.",
    /** `SignIn` draws only what is named here, so the other door's schemes get no dead button. */
    providers: {
      "microsoft-backoffice": "Microsoft (JBNL)",
    },
  },

  /** A developer tool on the sign-in page, labelled as one so it is never mistaken for a door. */
  dev: {
    badge: "debug",
    title: "Testaccounts",
    loading: "Testaccounts ophalen…",
    empty: "De seeder heeft nog geen testaccounts geschreven.",
    signInAs: "Inloggen als {{persoon}}",
    /** An ellipsis, not "Bezig…": the button is a cell code wide. */
    busy: "…",
    /** The persoon is not in the database - the seeder is older than the matrix. */
    missing: "ontbreekt",
    drift:
      "Wijkt af van de matrix. Herstart de API: de seeder zet de rechten terug.",

    columns: {
      code: "Cel",
      persoon: "Persoon",
      korpsen: "Korpsen",
      ondersteuner: "Ondersteuner",
      ondersteunerShort: "Ond.",
      beheerder: "Beheerder",
      beheerderShort: "Beh.",
    },

    korpsAccess: {
      None: "geen",
      OneKorps: "één korps",
      TwoKorpsen: "twee korpsen",
      ViaVeiligheidsregio: "via regio",
    },

    errors: {
      accounts: "Kon de testaccounts niet ophalen ({{status}}).",
      signIn: "Inloggen is mislukt ({{status}}).",
    },
  },

  errors: {
    signInFailed: "Inloggen is mislukt.",
    signInFailedWithStatus: "Inloggen is mislukt ({{status}}).",
    providersUnavailable: "Kon de inlogopties niet ophalen ({{status}}).",
    overzicht: "Kon het overzicht niet ophalen ({{status}}).",
    sessie: "Kon de sessie niet ophalen ({{status}}).",
  },
} as const;
